module.exports = __webpack_public_path__ + "static/develop_pictogram-beae2d2714d76443cced8e958d8f4a28.svg";